/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Group from "@material-ui/icons/Group";
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";
import DateRange from '@material-ui/icons/DateRange';
// import LockOutline from "@material-ui/icons/LockOutline";
import Check from "@material-ui/icons/Check";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FileUpload from "components/CustomUpload/FileUpload";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import NavPills from "components/NavPills/NavPills.jsx";

import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

import firebase from 'helpers/firebase';
import DaumPostcode from 'react-daum-postcode';
import Modal from "react-modal";

import { verifyEmail, verifyPhoneNumber, verifyNumber, verifyLength } from "components/Form/DXFormValidator";

import { createOrg } from "helpers/https";

import _ from "lodash";
import { uploadFile } from "helpers/storage";
import { uuidv4 } from "helpers/math";

import FirebaseUIAuth from "react-firebaseui-localized";

import { tos, privacy, privacy3rd } from './terms';
import { verifyDate } from "components/Form/DXFormValidator";

// Configure FirebaseUI.
const personalAccountConfig = {
  signInFlow: "popup",
  signInSuccessUrl: "/",
  signInOptions: [
    {
      provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      recaptchaParameters: {
        type: 'image', // 'audio'
        size: 'invisible', // 'invisible' or 'compact'
        badge: 'bottomleft' //' bottomright' or 'inline' applies to invisible.
      },
      defaultCountry: 'KR',
    },
    firebase.auth.EmailAuthProvider.PROVIDER_ID
  ],
  tosUrl: "/auth/terms",
  privacyPolicyUrl: "/auth/privacy"
};


const styles = {
  ...registerPageStyle,
}

class RegisterOrgPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkPrivacy: false,
      checkTos: false,
      checkPrivacy3rd: false,
      isReadyToSubmit: false,
      checked: [],
      addressModalIsOpen: false,
      data: {
        기관명: "",
        대표자이름: "",
        대표전화: "",
        사업장주소: "",
        대표이메일: "",
        비밀번호: "",
        계약시작일: "",
        계약종료일: "",
        사업자등록증: "",
      },
      verification: {
        기관명State: "",
        대표자이름State: "",
        대표전화State: "",
        사업장주소State: "",
        대표이메일State: "",
        비밀번호State: "",
        계약시작일State: "",
        계약종료일State: "",
        사업자등록증State: "success",
      }
    };
  }
  handleToggle = (value) => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked
    }, () => this.checkReadyToSubmit());
  }

  componentDidMount() {
    Modal.setAppElement('#root');
  }

  handleAddress = (returnData) => {
    let fullAddress = returnData.address;
    let extraAddress = '';

    if (returnData.addressType === 'R') {
      if (returnData.bname !== '') {
        extraAddress += returnData.bname;
      }
      if (returnData.buildingName !== '') {
        extraAddress += (extraAddress !== '' ? `, ${returnData.buildingName}` : returnData.buildingName);
      }
      fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
    }

    const { data, verification } = this.state;
    data["사업장주소"] = fullAddress;
    data["우편번호"] = returnData.zonecode;
    data["시군구코드"] = returnData.sigunguCode;
    data["시도코드"] = returnData.sigunguCode.substring(0, 1);
    verification["사업장주소State"] = "success";
    this.setState({
      addressModalIsOpen: false,
      data,
      verification,
    });

    console.log(JSON.stringify(returnData));  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  }

  onFileLoaded = (file) => {
    console.log(file);
    if (file.size > 5 * 1024 * 1024) {
      alert("파일 사이즈가 너무 큽니다. 5mb이하로 줄여서 올려주세요.");
      this.setState({ file: null });
      return;
    }
    const ext = _.last(file.name.split('.'));
    console.log("ext = ", ext);
    if (!['jpg', 'jpeg', 'png', 'pdf'].includes(ext.toLowerCase())) {
      alert("파일 형식을 확인해주세요. 허용가능한 파일 형식: jpg, png, pdf");
      this.setState({ file: null });
      return;
    }
    const { verification } = this.state;
    verification["사업자등록증State"] = "success";
    this.setState({ file, verification }, () => this.checkReadyToSubmit());
  }

  change = (event, stateName, typeInfo) => {
    // console.log('stateName = ', stateName);
    if (!typeInfo) {
      return;
    }

    const { type, params } = typeInfo;

    if (!type) {
      return;
    }

    let verified = true;
    switch (type) {
      case "email":
        verified = verifyEmail(event.target.value);
        break;
      case "phone":
        verified = verifyPhoneNumber(event.target.value);
        break;
      case "length":
        verified = verifyLength(event.target.value, params);
        break;
      case "number":
        verified = verifyNumber(event.target.value, params);
        break;
      case "date":
        verified = verifyDate(event.target.value);
      default:
        break;
    }

    const { data, verification } = this.state;

    verification[`${stateName}State`] = verified ? "success" : "error";
    data[stateName] = event.target.value;

    this.setState({ data, verification }, () => this.checkReadyToSubmit());
  }

  checkReadyToSubmit = () => {
    console.log("state = ", this.state);
    let pass = true;
    Object.keys(this.state.verification).some(key => {
      if (this.state.verification[key] !== "success") {
        pass = false;
        return;
      }
    })

    if (!pass) {
      return this.setState({ isReadyToSubmit: false });
    }

    return this.setState({ isReadyToSubmit: true });
  }

  save = () => {
    const { file, data, verification } = this.state;

    const foundIndex = _.findIndex(verification, item => item === "error")
    if (foundIndex > -1) {
      alert("입력 값을 확인해주세요.");
      return Promise.reject(Error("입력 값을 확인해주세요."));
    }

    // do upload
    if (file) {
      const path = `temp/business_licenses/${uuidv4()}`;
      console.log("storage path = ", path);
      uploadFile(file, path)
        .then(url => {
          console.log(`url = ${url}`)
          data['사업자등록증'] = url;
          // do save!
          return createOrg(data)
            .then(() => {
              alert("기관 생성 성공!");
              this.props.history.push('/auth/login-page');
            })
            .catch(e => {
              console.error(e);
              if (e.response.code === "409") {
                alert("이미 해당 기관이 존재합니다");
              } else {
                debugger;
                alert("기관생성 실패, 입력값을 확인하세요." + JSON.stringify(e.response.data));
              }
            });

        })
        .catch(e => console.error('failed to upload :', e))
    } else {
      // do save!
      return createOrg(data)
        .then(() => {
          alert("기관 생성 성공!");
          this.props.history.push('/auth/login-page');
        })
        .catch(e => {
          console.error(e);
          if (e.response.code === "409") {
            alert("이미 해당 기관이 존재합니다");
          } else {
            debugger;
            alert("기관생성 실패, 입력값을 확인하세요." + JSON.stringify(e.response.data));
          }
        });
    }
  }

  renderTerms = () => {
    return (
      <GridItem xs={12} md={6}>
        <GridContainer>
          {/* <GridItem xs={12}>
          <InfoArea
            title="엔브레인플랫폼"
            description="엔브레인플랫폼에서는 개인회원을 위해 엔브레인프로그램/정신건강테스트를 제공하고있습니다"
            icon={Timeline}
            iconColor="primary"
          />
        </GridItem> */}
        </GridContainer>
        <GridContainer>
          <GridItem>
            <Checkbox
              value={this.state.checkTos}
              onChange={(e) => this.setState({ checkTos: e.target.checked })} /> 서비스 약관에 동의합니다.
        </GridItem>
        </GridContainer>
        <GridContainer>
          < GridItem xs={12}>
            <textarea
              style={{ width: '100%', height: '200px' }}
              defaultValue={tos}
              readOnly
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem>
            <Checkbox
              value={this.state.checkPrivacy}
              onChange={(e) => this.setState({ checkPrivacy: e.target.checked })} /> 개인정보 보호 정책에 동의합니다.
        </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <textarea style={{ width: '100%', height: '200px' }}
              defaultValue={privacy}
              readOnly
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem>
            <Checkbox
              value={this.state.checkPrivacy3rd}
              onChange={(e) => this.setState({ checkPrivacy3rd: e.target.checked })} /> 개인정보 3자 제공에 관한 정책에 동의합니다.
        </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <textarea style={{ width: '100%', height: '200px' }}
              defaultValue={privacy3rd}
              readOnly
            />
          </GridItem>
        </GridContainer>
      </GridItem>
    )
  }

  renderSignUpPersonal = () => {
    const { classes } = this.props;

    return (
      <>
        <GridContainer justify='center'>
          <GridItem>
            <h3>개인 회원 가입하기</h3>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {this.renderTerms()}
          <GridItem xs={12} md={6}>
            <div style={{ padding: 30 }}>
              {
                this.state.checkPrivacy && this.state.checkTos && this.state.checkPrivacy3rd
                  ?
                  <FirebaseUIAuth
                    lang="ko"
                    config={personalAccountConfig}
                    auth={firebase.auth()}
                    firebase={firebase}
                  />
                  : <h5 className='text-info'><b>개인 회원 가입을 위해서 좌측의 이용약관과 개인정보 보호 정책에 동의해주세요.</b></h5>
              }
            </div>
          </GridItem>
        </GridContainer >
      </>

    )
  }


  renderSignUpFormOrg = () => {
    const { classes } = this.props;

    return (
      <form className={classes.form}>
        <CustomInput
          labelText="기관명"
          success={this.state.verification["기관명State"] === "success"}
          error={this.state.verification["기관명State"] === "error"}
          formControlProps={{
            fullWidth: true,
            className: classes.customFormControlClasses
          }}
          inputProps={{
            value: this.state.data["기관명"],
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.inputAdornment}
              >
                <Icon className={classes.inputAdornmentIcon}>
                  business
              </Icon>
              </InputAdornment>
            ),
            onChange: event => this.change(event, "기관명", {
              type: "length",
              params: {
                minLength: 2
              }
            }),
            placeholder: "기관명"
          }}
        />
        <CustomInput
          labelText="대표자이름"
          success={this.state.verification["대표자이름State"] === "success"}
          error={this.state.verification["대표자이름State"] === "error"}
          formControlProps={{
            fullWidth: true,
            className: classes.customFormControlClasses
          }}
          inputProps={{
            value: this.state.data["대표자이름"],
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.inputAdornment}
              >
                <Icon className={classes.inputAdornmentIcon}>
                  face
              </Icon>
              </InputAdornment>
            ),
            onChange: event => this.change(event, "대표자이름", {
              type: "length",
              params: {
                minLength: 2
              }
            }),
            placeholder: "대표자 이름"
          }}
        />
        <CustomInput
          labelText="대표전화"
          success={this.state.verification["대표전화State"] === "success"}
          error={this.state.verification["대표전화State"] === "error"}
          formControlProps={{
            fullWidth: true,
            className: classes.customFormControlClasses
          }}
          inputProps={{
            value: this.state.data["대표전화"],
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.inputAdornment}
              >
                <Icon className={classes.inputAdornmentIcon}>
                  phone
              </Icon>
              </InputAdornment>
            ),
            onChange: event => this.change(event, "대표전화", {
              type: "phone"
            }),
            placeholder: "대표 전화번호"
          }}
        />
        <CustomInput
          labelText="사업장주소"
          success={this.state.verification["사업장주소State"] === "success"}
          error={this.state.verification["사업장주소State"] === "error"}
          formControlProps={{
            fullWidth: true,
            className: classes.customFormControlClasses
          }}
          inputProps={{
            value: this.state.data["사업장주소"],
            ref: el => this.addressForm = el,
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.inputAdornment}
              >
                <Icon className={classes.inputAdornmentIcon}>
                  home
              </Icon>
              </InputAdornment>
            ),
            onChange: event => this.change(event, "사업장주소", {
              type: "length",
              params: {
                minLength: 8
              }
            }),
            placeholder: "사업장 주소",
            onFocus: (e) => {
              console.log("onFocus!!", e);
              e.target.blur();
              this.setState({ addressModalIsOpen: true });
            }
          }}
        />
        <CustomInput
          labelText="대표이메일"
          success={this.state.verification["대표이메일State"] === "success"}
          error={this.state.verification["대표이메일State"] === "error"}
          formControlProps={{
            fullWidth: true,
            className: classes.customFormControlClasses
          }}
          inputProps={{
            value: this.state.data["대표이메일"],
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.inputAdornment}
              >
                <Email className={classes.inputAdornmentIcon} />
              </InputAdornment>
            ),
            onChange: event => this.change(event, "대표이메일", {
              type: "email"
            }),
            placeholder: "대표 이메일주소"
          }}
        />
        <CustomInput
          labelText="비밀번호"
          success={this.state.verification["비밀번호State"] === "success"}
          error={this.state.verification["비밀번호State"] === "error"}
          formControlProps={{
            fullWidth: true,
            className: classes.customFormControlClasses
          }}
          inputProps={{
            value: this.state.data["비밀번호"],
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.inputAdornment}
              >
                <Icon className={classes.inputAdornmentIcon}>
                  lock_outline
              </Icon>
              </InputAdornment>
            ),
            placeholder: "비밀번호",
            onChange: event => this.change(event, "비밀번호", {
              type: "length",
              params: {
                minLength: 6
              }
            }),
            type: "password"
          }}
        />
        <CustomInput
          labelText="계약시작일"
          success={this.state.verification["계약시작일State"] === "success"}
          error={this.state.verification["계약시작일State"] === "error"}
          formControlProps={{
            fullWidth: true,
            className: classes.customFormControlClasses
          }}
          inputProps={{
            value: this.state.data["계약시작일"],
            type: 'date',
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.inputAdornment}
              >
                <DateRange className={classes.inputAdornmentIcon} />
              </InputAdornment>
            ),
            onChange: event => this.change(event, "계약시작일", {
              type: "date"
            }),
            placeholder: "계약 시작일자를 선택해주세요"
          }}
        />
        <CustomInput
          labelText="계약종료일"
          success={this.state.verification["계약종료일State"] === "success"}
          error={this.state.verification["계약종료일State"] === "error"}
          formControlProps={{
            fullWidth: true,
            className: classes.customFormControlClasses
          }}
          inputProps={{
            value: this.state.data["계약종료일"],
            type: 'date',
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.inputAdornment}
              >
                <DateRange className={classes.inputAdornmentIcon} />
              </InputAdornment>
            ),
            onChange: event => this.change(event, "계약종료일", {
              type: "date"
            }),
            placeholder: "계약 종료일자를 선택해주세요"
          }}
        />
        <FileUpload onFileLoaded={this.onFileLoaded} buttonTitle="사업자등록증 첨부하기" />

        <div className={classes.center}>
          <Button round color="primary" onClick={this.save} disabled={!this.state.isReadyToSubmit}>
            시작합니다
        </Button>
        </div>
      </form>
    )
  }

  renderSignUpOrganization = () => {

    return (
      <>
        <GridContainer justify='center'>
          <GridItem>
            <h3>기관 회원 가입하기</h3>
          </GridItem>
        </GridContainer>

        <GridContainer justify="center">
          {this.renderTerms()}
          <GridItem xs={12} md={6}>
            <div style={{ padding: 30 }}>
              {
                this.state.checkPrivacy && this.state.checkTos && this.state.checkPrivacy3rd
                  ? this.renderSignUpFormOrg()
                  : <h5 className='text-info'><b>기관 회원 가입을 위해서 좌측의 이용약관과 개인정보 보호 정책에 동의해주세요.</b></h5>
              }
            </div>
          </GridItem>
        </GridContainer >
      </>
    )
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardBody>
                <NavPills
                  color="info"
                  alignCenter
                  animateTransitions={false}
                  onChangeIndex={(idx) => {
                    console.log('idx = ', idx);
                    this.setState({ checkPrivacy: false, checkPrivacy3rd: false, checkTos: false })
                  }}
                  tabs={[
                    {
                      tabButton: "개인회원",
                      tabContent: this.renderSignUpPersonal()
                    },
                    {
                      tabButton: "기관회원",
                      tabContent: this.renderSignUpOrganization()
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <Modal
          isOpen={this.state.addressModalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={() => this.setState({ addressModalIsOpen: false })}
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
            },
            overlay: {
              // backgroundColor: 'papayawhip',
              zIndex: 100,
            },
          }}
        >
          <DaumPostcode
            onComplete={this.handleAddress}
            style={{ zIndex: 5, backgroundColor: 'red' }}

          />
        </Modal>
      </div>
    );
  }
}

RegisterOrgPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RegisterOrgPage);